export const getInitialState = (): any => ({
  deployStatusData: {},
  deployStStatus: 0
});
